import { createContext } from "react";
import { funcNotImplemented, funcNotImplementedAsync } from "utils/misc";
import { PaginationType, TableContextProps, TableProviderProps } from "./types";

import { useDevices } from "hooks";
import { useContext, useState } from "react";

const TableContext = createContext<TableContextProps>({
  data: [],
  totalPage: 1,
  isLoading: true,
  refreshTable: funcNotImplementedAsync,
  changePage: funcNotImplemented,
});

export function TableProvider(props: TableProviderProps) {
  const { children } = props;

  const [page, setPage] = useState<PaginationType>({ limit: 5, offset: 0 });
  const { devices, totalCount, itemPerPage, isLoading, mutate } = useDevices({
    limit: page.limit,
    offset: page.offset,
  });

  function changePage(page: number) {
    setPage({
      limit: 5,
      offset: (page - 1) * 5,
    });
  }

  async function refreshTable() {
    await mutate();
  }

  return (
    <TableContext.Provider
      value={{
        data: devices,
        isLoading: isLoading,
        totalPage: Math.ceil(totalCount / itemPerPage),
        refreshTable: refreshTable,
        changePage: changePage,
      }}
    >
      {children}
    </TableContext.Provider>
  );
}

export function useTableProvider() {
  return useContext(TableContext);
}
